<i18n
  src="@/locales/views/organization/production/query_by_producers/show_producer.yml"
  lang="yaml"
></i18n>
<template>
  <go-back-link :text="$t('labels.go_back_link')" :name="routeName('show_process_producers')" :params="{
    organization_id: organization_id,
    harvest_process_id: harvest_process_id
  }" />

  <template v-if="load_general_data">
    <bread-crumbs :labels="[
      module_name,
      agro_exporter_process.name,
      producer.fullname || producer.name
    ]" />

    <div class="mt-6 px-4">
      <tabs-container v-model="option_tabs" :with_routing="true" />
    </div>

    <div v-if="show_producer">
      <router-view
        :summary="summary"
        :harvests_monthly="harvests_monthly"
        :totals_monthly="totals_monthly"
        :crop_sizes="crop_sizes"
        :harvests_weekly="harvests_weekly"
        :totals_weekly="totals_weekly"
        :harvested_batches="harvested_batches"
      ></router-view>
    </div>
  </template>
</template>

<script>
import Requester from "@/views/organization/requesters/production/query_by_producers/show_producer.js";

export default {
  name: "OrgProductionQueryByProviderShowProvider",

  props: {
    organization_id: { required: true },
    harvest_process_id: { required: true },
    producer_id: { required: true },
    provider_type: { required: true }
  },

  data() {
    return {
      option_tabs: [],
      current_page: 1,
      total_exported_batches: 0,
      rows_per_page: 12,
      load_general_data: false,
      load_data_summary: false,
      load_data_weekly: false,
      load_data_details: false,
      agro_exporter_process: {},
      producer: {},
      harvested_batches: [],
      summary: {},
      harvests_monthly: {},
      harvests_weekly: {},
      totals_monthly: {},
      totals_weekly: {},
      crop_sizes: {}
    };
  },

  computed: {
    show_producer: function () {
      const route_name = this.$route.name;
      if (
        (route_name == this.routeName("show_producer_summary") &&
          this.load_data_summary) ||
        (route_name == this.routeName("show_producer_weekly") &&
          this.load_data_weekly) ||
        (route_name == this.routeName("show_producer_details") &&
          this.load_data_details)
      ) {
        return true;
      }
      return false;
    }
  },

  methods: {
    loadData: async function () {
      this.fillOptions();
      await this.fetchHarvestProcess();
      await this.fetchProducer();
      this.loadDataReports();
      this.load_general_data = true;
    },
    loadDataReports: function () {
      if (this.option_tabs[0].current && !this.load_data_summary)
        this.loadDataSummary();
      if (this.option_tabs[1].current && !this.load_data_weekly)
        this.loadDataWeekly();
      if (this.option_tabs[2].current && !this.load_data_details)
        this.loadDataDetails();
    },
    loadDataSummary: async function () {
      await this.fetchSummary();
      await this.fetchHarvestsMonthly();
      await this.fetchTotalsMonthly();
      await this.fetchCropSizes();
      this.load_data_summary = true;
    },
    loadDataWeekly: async function () {
      await this.fetchHarvestsWeekly();
      await this.fetchTotalsWeekly();
      this.load_data_weekly = true;
    },
    loadDataDetails: async function () {
      await this.fetchHarvestedBatches();
      this.load_data_details = true;
    },
    fetchHarvestProcess: async function () {
      let response = await Requester.fetchHarvestProcess(
        this.organization_id,
        this.harvest_process_id
      );
      this.agro_exporter_process = response.data;
    },
    fetchProducer: async function () {
      let response = await Requester.fetchProducer(
        this.organization_id,
        this.harvest_process_id,
        this.provider_type,
        this.producer_id
      );
      this.producer = response.data;
    },
    fetchSummary: async function () {
      let response = await Requester.fetchSummary(
        this.organization_id,
        this.harvest_process_id,
        this.provider_type,
        this.producer_id
      );
      this.summary = response.data;
    },
    fetchHarvestsMonthly: async function () {
      let response = await Requester.fetchHarvestsMonthly(
        this.organization_id,
        this.harvest_process_id,
        this.provider_type,
        this.producer_id
      );
      this.harvests_monthly = response.data;
    },
    fetchHarvestsWeekly: async function () {
      let response = await Requester.fetchHarvestsWeekly(
        this.organization_id,
        this.harvest_process_id,
        this.provider_type,
        this.producer_id
      );
      this.harvests_weekly = response.data;
    },
    fetchTotalsMonthly: async function () {
      let response = await Requester.fetchTotalsMonthly(
        this.organization_id,
        this.harvest_process_id,
        this.provider_type,
        this.producer_id
      );
      this.totals_monthly = response.data;
    },
    fetchTotalsWeekly: async function () {
      let response = await Requester.fetchTotalsWeekly(
        this.organization_id,
        this.harvest_process_id,
        this.provider_type,
        this.producer_id
      );
      this.totals_weekly = response.data;
    },
    fetchCropSizes: async function () {
      let response = await Requester.fetchCropSizes(
        this.organization_id,
        this.harvest_process_id,
        this.provider_type,
        this.producer_id
      );
      this.crop_sizes = response.data;
    },
    fetchHarvestedBatches: async function () {
      let response = await Requester.fetchHarvestedBatches(
        this.organization_id,
        this.harvest_process_id,
        this.provider_type,
        this.producer_id,
        this.current_page,
        this.rows_per_page
      );
      this.harvested_batches = response.data;
      this.fillPercentValues();
    },
    fetchTotalPages: async function () {
      let response = await Requester.fetchHarvestedBatchesTotal(
        this.organization_id,
        this.harvest_process_id
      );
      this.total_exported_batches = response.data;
      this.available_pages = Array.from(
        { length: Math.ceil(this.total_exported_batches / this.rows_per_page) },
        (_, i) => i + 1
      );
    },
    fillPercentValues() {
      this.harvested_batches.forEach(exported_batch => {
        const discarded_percent = this.discardPercent(exported_batch);
        exported_batch["discarded_percent"] = discarded_percent;
        exported_batch["ok_percent"] = 100 - discarded_percent;
      });
    },
    discardPercent(exported_batch) {
      let percent =
        (Number(exported_batch.discarded_weight) /
          Number(exported_batch.total_weight)) *
        100;
      return Math.round(percent);
    },
    fillOptions: function () {
      this.option_tabs = [
        {
          name: this.$t("labels.tabs.summary"),
          icon: "fa-solid fa-chart-pie",
          route: { name: this.routeName("show_producer_summary") },
          current: this.$route.name == this.routeName("show_producer_summary")
        },
        {
          name: this.$t("labels.tabs.weekly"),
          icon: "fa-solid fa-chart-line",
          route: { name: this.routeName("show_producer_weekly") },
          current: this.$route.name == this.routeName("show_producer_weekly")
        },
        {
          name: this.$t("labels.tabs.details"),
          icon: "fa-solid fa-list",
          route: { name: this.routeName("show_producer_details") },
          current: this.$route.name == this.routeName("show_producer_details")
        }
      ];
    }
  },

  watch: {
    option_tabs() {
      this.loadDataReports();
    }
  },

  created() {
    this.checkIfAuthenticated().then(() =>
      this.checkIfAuthorized({
        role: this.$route.meta.role,
        permission: this.$route.meta.permission,
        entity: {
          organization_id: this.organization_id
        }
      }).then(() => this.loadData())
    );
  }
};
</script>
